import { StateCreator } from 'zustand';

import { NavigationSlice } from './types';

const navigationSlice: StateCreator<NavigationSlice> = (set) => ({
  view: 'global',
  setView(view) {
    set({ view });
  },
  reconciliationType: 'deductions',
  setReconciliationType(reconciliationType) {
    set({ reconciliationType });
  },
});

export default navigationSlice;
